import Vue from 'vue';
import { getProfile } from '../../../services/personnelService/qrCodeService';
import { changeProfilePicture } from '../../../services/backendService/profileService';

// initial state
// state 必為模組區域變數，取時需 store.state.auth.user
// 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
// 區域使用時值需加上 name
const state = {
  data: null,
  profileImgUrl: null
};

// getters
const getters = {};

// actions
const actions = {
  // 取得顧問 Profile
  async getProfileHandler({ commit }) {
    const data = await getProfile();
    commit('setData', data.data);
    return data;
  },
  async changeProfilePictureHandler({ commit }, formData) {
    const data = await changeProfilePicture(formData);
    commit('setProfileImgUrl', data);
  }
};

// mutations
const mutations = {
  setData(state, data) {
    Vue.set(state, 'data', data.personnel);
    Vue.set(state, 'profileImgUrl', data.personnel.picture_url);
  },
  setProfileImgUrl(state, data) {
    Vue.set(state, 'profileImgUrl', data.data.picture_url);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
